module.exports = __webpack_public_path__ + "img/website-service-04.7ea5ad54.png";